import {
  TFetchGuestMessagesAggregatedAnalyticsQueryParams,
  TFetchGuestMessagesCountAnalyticsQueryParams,
} from "src/data/guestAnalytics/guestAnalyticsTypes"

export const guestAnalyticsKeys = {
  all() {
    return ["guestAnalytics"] as const
  },

  guestMessagesCount({
    orgId,
    filters,
  }: {
    orgId: string
    filters: TFetchGuestMessagesCountAnalyticsQueryParams
  }) {
    if (filters) {
      return [...this.all(), "guestMessagesCount", orgId, filters] as const
    }

    return [...this.all(), "guestMessagesCount", orgId] as const
  },

  guestMessagesAggregated({
    orgId,
    filters,
  }: {
    orgId: string
    filters: TFetchGuestMessagesAggregatedAnalyticsQueryParams
  }) {
    if (filters) {
      return [...this.all(), "guestMessagesAggregated", orgId, filters] as const
    }

    return [...this.all(), "guestMessagesAggregated", orgId] as const
  },
} as const
